var _defs, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Abstract user icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circular-border"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 280
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avoid-antialiasing-bugs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 498
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 280,
    fill: "#ffb800",
    clipPath: "url(#avoid-antialiasing-bugs)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 230,
    r: 115
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 550,
    r: 205,
    clipPath: "url(#circular-border)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownProfile);
export default __webpack_public_path__ + "static/media/unknown-profile.34781e70ecff392430cf5887d244e33e.svg";
export { ForwardRef as ReactComponent };